import { useLocation } from '@reach/router';

/**
 * Uses the URL hash to determinine which form to display.
 * @returns {Array} An array of strings representing the categories.
 * @returns {String} A string representing the category at the requested depth (defaults to 0).
 */
function useFormCategories({ depth: depth = 0 }) {
  const location = useLocation();
  const categories = location.hash.slice(1).split('/');
  return [categories, categories[depth] ? categories[depth] : ''];
};

export default useFormCategories;